import { const_var, params } from "../../../redux/reducers/reducer";
import * as utils from "../../../redux/reducers/utils";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import { findWainscotTexture, setWainscotDefault } from "./wainscotColor.helper";
const toHex = (hex) => hex?.replace("#", "0x");
export function getBuildingColor(state, colors) {
	const defaultClr = colors[0];
	if (!defaultClr) return;
	const defaultHex = toHex(defaultClr.hex_value);
	const roofColor = { hex: defaultHex, name: defaultClr.name, id: defaultClr.id };
	const wallColor = { hex: defaultHex, name: defaultClr.name, id: defaultClr.id };
	const trimColor = { hex: defaultHex, name: defaultClr.name, id: defaultClr.id };
	const wainscotColor = { hex: defaultHex, name: defaultClr.name, id: defaultClr.id };

	const_var.defaultBuildingColorArray["RoofColor"] = roofColor.hex;
	const_var.defaultBuildingColorArray["WallColor"] = wallColor.hex;
	const_var.defaultBuildingColorArray["TrimColor"] = trimColor.hex;
	const_var.defaultBuildingColorArray["WainscotColor"] = wainscotColor.hex;
	const_var.defaultBuildingColorArray["mainColorObject"] = colors;

	const_var.color = colors;
	state.const_var.color = colors;
	state.newColor = colors;

	for (const color of colors) {
		const entry = { ...color };
		const_var.c_m_a_Colors[toHex(color.hex_value)] = entry;
		const_var.c_m_a_Colors[color.id] = entry;
	}
}

export function updateColor(state, action) {
	let newColor = "";
	if (state.params.p_w_c_n && action.str == "Wall" && action?.value?.sheet_name != "metal") {
		setWainscotDefault(const_var.c_m_a, params, const_var.color);
	}
	if (action.str == "Roof") {
		state.params.p_r_c = action.value.hex_value.replace("#", "0x");
		state.params.p_r_c_name = action.value.name;
		state.params.p_r_c_id = action.value.id;
		newColor = action.str + state.params.p_r_c;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
	} else if (action.str == "Trim") {
		state.params.p_t_c = action.value.hex_value.replace("#", "0x");
		state.params.p_t_c_name = action.value.name;
		state.params.p_t_c_id = action.value.id;
		newColor = action.str + state.params.p_t_c;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
	} else if (action.str == "Wall") {
		state.params.p_w_c = action.value.hex_value.replace("#", "0x");
		state.params.p_w_c_name = action.value.name;
		state.params.p_w_c_id = action.value.id;
		newColor = action.str + state.params.p_w_c;
		if (action.value.image_name) {
			let sidingName = action.value.image_name.split(".")[0];
			params.wallTexture = utils.sidingNameUpdateForWallTexture(sidingName);
			const_var.selSidingOption = action.value.sheet_name;
			if (params.wallTexture == "none" || params.wallTexture == "vertical") const_var.selSidingOption = "metal";
			newColor = action.str + state.params.p_w_c + sidingName;
		}
		const_var.UpdatedPriceData.wall_color_price_changed = true;
	} else if (action.str == "Wainscot") {
		if (action.value.sheet_name != undefined && action.value.sheet_name != "metal" && const_var.TypeEnum[state.params.p_r_s] == "Regular" && params.m_s_n != 12) {
			let checkColorExist = const_var.color
				?.filter((clr) => {
					if (clr?.sheet_name == "metal") {
						return clr;
					}
				})
				?.find((clr) => clr.hex_value?.replace("#", "0x") == params.p_w_c_c);

			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RegularRoofStyleTextureChange";
			if (checkColorExist == undefined) {
				params.wainscotTexture = "none";
				const_var.UpdatedPriceData.wainscot_color_price = true;
				state.params.p_w_c_c = state.params.p_t_c;
				state.params.p_w_c_c_name = state.params.p_t_c_name;
				state.params.p_w_c_c_id = state.params.p_t_c_id;
				newColor = action.str + state.params.p_t_c + params.wainscotTexture;
			}
		} else {
			params.wainscotTexture = findWainscotTexture(action.value);
			const_var.UpdatedPriceData.wainscot_color_price = true;
			state.params.p_w_c_c = action.value.hex_value.replace("#", "0x");
			state.params.p_w_c_c_name = action.value.name;
			state.params.p_w_c_c_id = action.value.id;
			newColor = action.str + state.params.p_w_c_c + params.wainscotTexture;
		}
		const_var.UpdatedPriceData.wainscot_price_changed = true;
	} else if (action.str == "Door") {
		state.params.g_d_c = action.value.hex_value.replace("#", "0x");
		state.params.g_d_c_name = action.value.name;
		state.params.g_d_c_id = action.value.id;
		newColor = action.str + state.params.g_d_c;
	}
	state.selectedID = state.params.p_w_c;
	cuBuilding.cP();
	return {
		...state,
		newColor: newColor
	};
}
const getColorById = (colors, id) => {
	return colors?.find((color) => color.id === id) || null;
};

export const applyColorToParams = (keyPrefix, color) => {
	if (!color) return;
	const hex = color?.hex_value?.replace("#", "0x");
	params[keyPrefix] = hex;
	params[`${keyPrefix}_name`] = color.name;
	params[`${keyPrefix}_id`] = color.id;
};
export function setDefaultBuildingColorById(colors, selectedBuilding) {
	if (!colors || !selectedBuilding) return;
	const roofColor = getColorById(colors, selectedBuilding.roof_color);
	const trimColor = getColorById(colors, selectedBuilding.trim_color);
	const wallColor = getColorById(colors, selectedBuilding.wall_color);
	const wainScotColor = getColorById(colors, selectedBuilding.wainscot_color);
	applyColorToParams("p_r_c", roofColor);
	applyColorToParams("p_t_c", trimColor);
	applyColorToParams("p_w_c", wallColor);
	if (selectedBuilding.wainscot_color) {
		params.p_w_c_n = true;
		applyColorToParams("p_w_c_c", wainScotColor);
	}
}
export const assigRWTWColors = (comparisionData, params, from) => {
	if (comparisionData != undefined && comparisionData?.paramsData) {
		let defualtBuildingData = comparisionData.building_data.default_building.filter((building) => params.building_type_name.includes(building.name))[0];

		let defualtBuildingWallColorId = defualtBuildingData != undefined && defualtBuildingData.wall_color != undefined ? defualtBuildingData.wall_color : comparisionData.building_data.color[0];
		let defualtBuildingRoofColorId = defualtBuildingData != undefined ? defualtBuildingData.roof_color : comparisionData.building_data.color[0];
		let defualtBuildingTrimColorId = defualtBuildingData != undefined ? defualtBuildingData.trim_color : comparisionData.building_data.color[0];
		let defualtBuildingWainscotColorId = defualtBuildingData != undefined ? defualtBuildingData.wainscot_color : comparisionData.building_data.color[0];

		let WallColorObj =
			comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_name)[0] != undefined
				? comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_name)[0]
				: defualtBuildingWallColorId !== undefined && comparisionData.building_data.color.filter((data) => data.id == defualtBuildingWallColorId)[0] != undefined
					? comparisionData.building_data.color.filter((data) => data.id == defualtBuildingWallColorId)[0]
					: comparisionData.building_data.color[0];

		let RoofColorObj =
			comparisionData.building_data.color.filter((data) => data.name == params.p_r_c_name)[0] != undefined
				? comparisionData.building_data.color.filter((data) => data.name == params.p_r_c_name)[0]
				: defualtBuildingRoofColorId !== undefined && comparisionData.building_data.color.filter((data) => data.id == defualtBuildingRoofColorId)[0] != undefined
					? comparisionData.building_data.color.filter((data) => data.id == defualtBuildingRoofColorId)[0]
					: comparisionData.building_data.color[0];

		let TrimColorObj =
			comparisionData.building_data.color.filter((data) => data.name == params.p_t_c_name)[0] != undefined
				? comparisionData.building_data.color.filter((data) => data.name == params.p_t_c_name)[0]
				: defualtBuildingTrimColorId !== undefined && comparisionData.building_data.color.filter((data) => data.id == defualtBuildingTrimColorId)[0] != undefined
					? comparisionData.building_data.color.filter((data) => data.id == defualtBuildingTrimColorId)[0]
					: comparisionData.building_data.color[0];

		let WainscotColorObj = "";
		if (defualtBuildingData != undefined && defualtBuildingData?.wainscot_color != undefined) {
			WainscotColorObj =
				comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_c_name)[0] != undefined
					? comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_c_name)[0]
					: defualtBuildingWainscotColorId !== undefined && comparisionData.building_data.color.filter((data) => data.id == defualtBuildingWainscotColorId)[0] != undefined
						? comparisionData.building_data.color.filter((data) => data.id == defualtBuildingWainscotColorId)[0]
						: comparisionData.building_data.color[0];
		} else {
			WainscotColorObj =
				comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_c_name)[0] != undefined
					? comparisionData.building_data.color.filter((data) => data.name == params.p_w_c_c_name)[0]
					: defualtBuildingTrimColorId !== undefined && comparisionData.building_data.color.filter((data) => data.id == defualtBuildingTrimColorId)[0] != undefined
						? comparisionData.building_data.color.filter((data) => data.id == defualtBuildingTrimColorId)[0]
						: comparisionData.building_data.color[0];
		}
		comparisionData.paramsData.p_r_c_name = RoofColorObj?.name;
		comparisionData.paramsData.p_t_c_name = TrimColorObj.name;
		comparisionData.paramsData.p_w_c_name = WallColorObj.name;
		comparisionData.paramsData.p_w_c_c_name = WainscotColorObj?.name;
		if (from == "comparePriceData") {
			return { WallColorObj, RoofColorObj, TrimColorObj, WainscotColorObj };
		}
	}
};
